



import { UserModule } from '@/store/modules/user';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Home extends Vue {
  mounted() {
    const { code } = this.$route.query;
    if (code && typeof code === 'string') {
      let pathname = process.env.NODE_ENV === 'production' ? '/admin' : '';
      if(location.pathname.startsWith('/en')) {
        pathname = '/en' + pathname
      }
      UserModule.JAccount({ code, redirectUrl: location.origin + pathname + '/cb' })
        .then(() => {
          this.$router.push('/');
        })
        .catch(() => {
          this.$router.push('/login');
        });
    }
  }
}
